import { render, staticRenderFns } from "./ModalDetails.vue?vue&type=template&id=9a7dfa10&scoped=true&"
import script from "./ModalDetails.vue?vue&type=script&lang=js&"
export * from "./ModalDetails.vue?vue&type=script&lang=js&"
import style0 from "./ModalDetails.vue?vue&type=style&index=0&id=9a7dfa10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a7dfa10",
  null
  
)

export default component.exports